import {AnalyticsEventMetadata} from 'analytics/AnalyticsTypes';
import {DataModificationsHeader} from 'audit/DataModifications';
import {MinimalSchemaTag} from 'folder-items/FileConstants';
import {NotePartIndex} from 'notebook/util/EntryNoteIndexUtil';
import {AnnotateFixedPlateWellInput, FixedPlateTransferInputWell} from 'samples/GridDAO';
import {PlateDesignVersionRef} from 'samples/plate-maps/plate-record/PlateRecordConstants';
import * as net from 'util/Net';

interface SharedAnnotateFillFixedPlateParams {
  annotations: Array<AnnotateFixedPlateWellInput>;
  transferInputs: Array<FixedPlateTransferInputWell>;
  plateRecordName: string;
  notePartIndex: NotePartIndex;
  plateDesignVersionRef: PlateDesignVersionRef | null;
  procedureMethodExecutionInstanceId: string | null;
}

export interface AnnotateFillFixedPlateParams extends SharedAnnotateFillFixedPlateParams {
  gridId: string;
  schemaFieldValues: {[apiId: string]: Partial<MinimalSchemaTag>};
  appendStudyIds: Array<string>;
}

export function annotateFillFixedPlate(
  fileId: string,
  data: AnnotateFillFixedPlateParams,
  analyticsMetadata: AnalyticsEventMetadata,
  dataModsHeader?: DataModificationsHeader
): Promise<void> {
  return net.postJSONPromise({
    url: `/1/api/entries/${fileId}/annotate-fill-fixed-plate`,
    data,
    analyticsMetadata,
    extraHeaders: dataModsHeader,
  });
}

export interface CreateFixedPlateParams {
  barcode: string | null;
  location_id: string | null;
  source_id: string | null;
  tags: {[apiId: string]: Partial<MinimalSchemaTag>} | null;
  study_ids: Array<string> | null;
  schema_id: string;
  name: string;
}

export interface AnnotateFillNewFixedPlateParams extends SharedAnnotateFillFixedPlateParams {
  plateParameters: CreateFixedPlateParams;
}

export function annotateFillNewFixedPlate(
  fileId: string,
  data: AnnotateFillNewFixedPlateParams,
  analyticsMetadata: AnalyticsEventMetadata,
  dataModsHeader?: DataModificationsHeader
): Promise<{plateId: string}> {
  return net.postJSONPromise({
    url: `/1/api/entries/${fileId}/create-annotate-fill-fixed-plate`,
    data,
    analyticsMetadata,
    extraHeaders: dataModsHeader,
  });
}
